import { Response } from 'miragejs';
import { API_URLS } from 'pages/leads/constants';
import { URL_INTEGRATORS_LIST, URL_LEAD_INFO } from 'utils/api-urls';

import {
  CATEGORIES_MOCK,
  INTERGRATORS_MOCK,
  LEAD_INFO_MOCK,
  MOCK_FULL_LEAD,
  MOCK_REVENUES,
} from './pre-signup.mock';

export default function preSignupRoutes(server) {
  server.post(
    API_URLS.preSignup,
    () => new Response(201, {}, { redirectTo: '/setup/requisites', lead_id: LEAD_INFO_MOCK.id })
  );
  server.post(
    API_URLS.getRequisites({ leadId: LEAD_INFO_MOCK.id }),
    () =>
      new Response(
        201,
        {},
        {
          redirectTo: '/setup/categories',
          lead_id: LEAD_INFO_MOCK.id,
          status: 'qualified',
        }
      )
  );
  server.get(
    API_URLS.getUnqualifiedProfile({ leadId: LEAD_INFO_MOCK.id }),
    () =>
      new Response(
        200,
        {},
        {
          has_bank_account_associated_cnpj: false,
          has_nfe_xml: false,
          respect_correios_max_dimensions: false,
          has_valid_state: false,
        }
      )
  );
  server.get(URL_INTEGRATORS_LIST, () => new Response(200, {}, INTERGRATORS_MOCK));
  server.get(URL_LEAD_INFO(LEAD_INFO_MOCK.id), () => new Response(200, {}, LEAD_INFO_MOCK));
  server.get(
    API_URLS.getRequisites({ leadId: LEAD_INFO_MOCK.id }),
    () => new Response(200, {}, {})
  );
  server.get(API_URLS.getCategories, () => new Response(200, {}, CATEGORIES_MOCK));

  server.post(
    API_URLS.getCategories,
    () =>
      new Response(
        201,
        {},
        { redirectTo: '/setup/shop-windows', lead_id: LEAD_INFO_MOCK.id, isQualified: false }
      )
  );

  server.get(
    `/bff/acquisition/v1/leadsV2/full-lead/&email=teste199@olist.com`,
    () => new Response(200, {}, MOCK_FULL_LEAD)
  );

  server.get(API_URLS.getRevenues, () => new Response(200, {}, MOCK_REVENUES));
  server.patch(
    API_URLS.patchRevenues,
    () =>
      new Response(
        200,
        {},
        {
          redirectTo: '/setup/create-password',
          lead_id: LEAD_INFO_MOCK.id,
          revenue: '123123-123123',
        }
      )
  );
  server.post(API_URLS.postAccountCreation, new Response(200, {}, {}));
}
